export default __webpack_public_path__ + "static/media/Navbharat_aug 21 2022.3b6d4f21.jpg";